import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

import './css/About.css'
import AboutText from './text/about-text'

const Subheaders = ['Diligence', 'Persistence', 'Inquisitive and Receptive', 'Identifying and Solving Problems']

export default class About extends React.Component {
  renderHeaderText = (header, idx) => (
    <div key={header} className="section">
      <div className="blue-subheader">{header}</div>
      <div className="small-text">{AboutText[idx + 1]}</div>
    </div>
  )

  renderAboutContainer = () => (
    <div className="about-container">
      <div className="about-subcontainer">
        <div className="about-header">ABOUT AcademME</div>
        <div className="section">
          <div className="about-subheader">MISSION</div>
          <div className="small-text">{AboutText[0]}</div>
        </div>
        <div className="section">
          <div className="about-subheader">VISION</div>
          <div className="about-blue-text">{AboutText[1]}</div>
        </div>
      </div>
      <div className="about-subcontainer values">
        <div className="about-values">
          <div className="section">
            <div className="about-subheader">VALUES</div>
            <div className="blue-subheader">Honesty</div>
            <div className="small-text">{AboutText[2]}</div>
          </div>
          {Subheaders.map(this.renderHeaderText)}
        </div>
      </div>
      <div className="about-subcontainer">
        <div className="section">
          <div className="about-subheader">APPROACH</div>
          {AboutText.slice(7, 12).map(this.renderBulletPoint)}
        </div>
      </div>
    </div>
  )

  renderBulletPoint = text => (
    <div key={text} className="small-text margin">{text}</div>
  )

  render() {
    return (
      <CSSTransitionGroup
        transitionName="slide"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionLeaveTimeout={500}
        transitionEnter={false}
        transitionLeave={true}>
        {this.renderAboutContainer()}
      </CSSTransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// src/About.js